import axios from 'axios'
import { LIST_INDUSTRIES } from '@/store/getter.types'
import { FETCH_INDUSTRIES } from '@/store/action.types'
import { SET_INDUSTRIES } from '@/store/mutation.types'

export const state = {
  industries: []
}

export const getters = {
  [LIST_INDUSTRIES]: state => Object.freeze(state.industries)
}

export const actions = {
  async [FETCH_INDUSTRIES] ({commit}) {
    const response = await axios.get('/search/industries/')
    response.data.forEach((record) => {
      record.value = record.industry_id
    })
    commit(SET_INDUSTRIES, response.data)
  }
}

export const mutations = {
  [SET_INDUSTRIES] (state, industries) {
    state.industries = Object.freeze(industries)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/industries.js